import type { IProductList } from '~~/lib/ContentfulService';
import { PRODUCT_LIST_VIEW_KEY } from '../constants';

export type ProductListView = NonNullable<IProductList['fields']['view']>;

export function parseStoredProductListView(
  storedView: string | null
): ProductListView | null {
  if (storedView === 'grid' || storedView === 'table-list') {
    return storedView;
  }

  return null;
}

export function readStoredProductListViewFromStorage(
  storage: Pick<Storage, 'getItem'>
): ProductListView | null {
  return parseStoredProductListView(storage.getItem(PRODUCT_LIST_VIEW_KEY));
}

export function readStoredProductListView(): ProductListView | null {
  if (!import.meta.client) {
    return null;
  }

  return readStoredProductListViewFromStorage(window.localStorage);
}

export function resolveProductListView(
  cmsDefault: ProductListView
): ProductListView {
  return readStoredProductListView() ?? cmsDefault;
}
